import * as React from "react";
import { MediaQuery, Util } from "@grandvisionhq/common";
import { ResponsiveImage, Heading } from "@grandvisionhq/elements";
import BlogMeta from "../../../../BlogMeta/components/Blog/BlogMeta/BlogMeta.js";
/* empty css              */
const BlogCard = ({
  image,
  mobileImage,
  title,
  locale,
  readingTime,
  publishDate,
  summary,
  url,
  minutesLabel
}) => {
  const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
  const imageUrl = isSmallScreen && mobileImage ? mobileImage.url : image?.url;
  if (!imageUrl && !title && !summary) {
    console.error(
      "BlogCard: missing content, please supply an image, mobileImage, title or summary"
    );
    return null;
  }
  const defaultImgSizes = {
    M: 768,
    // single column
    L: 512,
    // two columns
    XL: 720,
    // two columns
    MAX: 960
    // two columns
  };
  const defaultParams = { fit: "fillmax" };
  const extraPixelDensities = [2];
  const srcSet = Util.createImageSrcSet(imageUrl ?? "", defaultImgSizes, defaultParams, {
    extraPixelDensities
  });
  const sizes = Util.createImageSizes(defaultImgSizes, imageUrl ?? "", {
    extraPixelDensities
  });
  return /* @__PURE__ */ React.createElement("a", { className: "blog-card", href: url }, /* @__PURE__ */ React.createElement("div", { className: "blog-card__content" }, image && imageUrl && /* @__PURE__ */ React.createElement(
    ResponsiveImage,
    {
      className: "blog-card__image",
      src: imageUrl,
      srcSet,
      sizes,
      alt: image.alt ?? ""
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "blog-card__text" }, title && /* @__PURE__ */ React.createElement(Heading, { variant: "smallest", component: "h2", className: "blog-card__title" }, Util.truncateString(title, 50)), summary && /* @__PURE__ */ React.createElement("p", { className: "blog-card__paragraph" }, Util.truncateString(summary, 200)), /* @__PURE__ */ React.createElement(
    BlogMeta,
    {
      publishDate,
      readingTime,
      minutesLabel,
      locale
    }
  ))));
};
const BlogCard$1 = React.memo(BlogCard);
export {
  BlogCard$1 as default
};
//# sourceMappingURL=BlogCard.js.map
